import { render } from "./PhysicianEdit.vue?vue&type=template&id=23bd6648"
import script from "./PhysicianEdit.vue?vue&type=script&lang=js"
export * from "./PhysicianEdit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/physicians/PhysicianEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23bd6648"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23bd6648', __exports__)) {
    console.log('reload')
    api.reload('23bd6648', __exports__)
  }
  
  module.hot.accept("./PhysicianEdit.vue?vue&type=template&id=23bd6648", () => {
    console.log('re-render')
    api.rerender('23bd6648', render)
  })

}


export default __exports__